import { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '../ui/dialog';
import { TIPOS_EQUIPAMENTO } from './periodicidades';

export default function DialogTabelaManutencao({ aberto, tabela, onFechar, onSalvar }) {
    const [nome, setNome] = useState('');
    const [tipoEquipamento, setTipoEquipamento] = useState('');
    const [salvando, setSalvando] = useState(false);

    useEffect(() => {
        if (!aberto) return;
        setNome(tabela?.nome ?? '');
        setTipoEquipamento(tabela?.tipoEquipamento ?? '');
    }, [aberto, tabela]);

    const salvar = async (e) => {
        e.preventDefault();
        if (salvando || nome.trim() === '') return;
        setSalvando(true);
        try {
            const ok = await onSalvar({ nome: nome.trim(), tipoEquipamento: tipoEquipamento || null });
            if (ok) onFechar();
        } finally {
            setSalvando(false);
        }
    };

    return (
        <Dialog open={aberto} onOpenChange={(v) => !v && !salvando && onFechar()}>
            <DialogContent>
                <form onSubmit={salvar} className="flex flex-col gap-4">
                    <DialogHeader>
                        <DialogTitle>{tabela ? 'Editar tabela de manutenção' : 'Nova tabela de manutenção'}</DialogTitle>
                    </DialogHeader>
                    <label className="flex flex-col gap-1 text-lg">
                        Nome
                        <input
                            type="text"
                            value={nome}
                            maxLength={150}
                            autoFocus
                            disabled={salvando}
                            onChange={(e) => setNome(e.target.value)}
                            className="bg-gray-800 text-white border border-gray-700 rounded px-3 py-2 focus:outline-none focus:border-accent disabled:opacity-50"
                        />
                    </label>
                    <label className="flex flex-col gap-1 text-lg">
                        Equipamentos
                        <select
                            value={tipoEquipamento}
                            disabled={salvando}
                            onChange={(e) => setTipoEquipamento(e.target.value)}
                            className="bg-gray-800 text-white border border-gray-700 rounded px-3 py-2 focus:outline-none focus:border-accent disabled:opacity-50"
                        >
                            <option value="">Nenhum (tarefas da unidade)</option>
                            {TIPOS_EQUIPAMENTO.map((t) => (
                                <option key={t.valor} value={t.valor}>Todos os {t.nome.toLowerCase()}</option>
                            ))}
                        </select>
                        <span className="text-base text-gray-400">
                            Com um tipo selecionado, cada ação gera uma única tarefa que vale para todos os equipamentos desse tipo, com aviso no monitoramento geral.
                        </span>
                    </label>
                    <DialogFooter>
                        <button
                            type="submit"
                            disabled={salvando || nome.trim() === ''}
                            className="bg-accent text-white px-4 py-2 rounded-md text-lg disabled:opacity-50"
                        >
                            Salvar
                        </button>
                    </DialogFooter>
                </form>
            </DialogContent>
        </Dialog>
    );
}
